module.exports = __webpack_public_path__ + "static/img/goldMiner.64ffdb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameImg/goldMiner.png
// module id = uKq3
// module chunks = 1